export default "__VITE_ASSET__CKoCsZka__"